import { FormLabel, InputGroup, InputLeftAddon, Select } from "@chakra-ui/react";
import { sortAlphabeticallyByAttribute } from "../../../utils";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { FaFilter } from "react-icons/fa";

function FilterBySupplier({ suppliers, supplierFilter, setSupplierFilter }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "suppliersLocations"
  });

  return (
    <>
      <FormLabel
        htmlFor={"filterBySupplierSelect"}
        opacity="0.75"
        fontSize="xs"
        whiteSpace="nowrap"
        blockSize="5"
        isTruncated
        color="esg_gray.200"
        marginBottom={0}
      >
        {t("filterBySupplierSelect")}
      </FormLabel>
      <InputGroup>
        <InputLeftAddon children={<FaFilter color={supplierFilter !== "" ? "green" : ""} opacity="0.7" />} />
        <Select
          id={"filterBySupplierSelect"}
          placeholder={" "}
          backgroundColor="white"
          borderRadius="none"
          value={supplierFilter}
          onChange={(e) => setSupplierFilter(e.target.value)}
          maxInlineSize={{ base: "xs", lg: "250px" }}
          title={suppliers?.find(el => el.id === supplierFilter)?.name ?? ""}
        >
          {suppliers
            .sort((a, b) => sortAlphabeticallyByAttribute(a, b, "name"))
            .map(supplier => <option key={supplier.id} value={supplier.id}>{supplier.name}</option>)
          }
        </Select>
      </InputGroup>
    </>
  );
}

export default FilterBySupplier;